import { SVC_A, SVC_B } from './base'
import { router } from '@/router'
// import {entitlements} from '@/libraries/api/mocks'

export { validateTokenForProvider, loadPermissionsForUser }

/**
 * Login to Owal with a given token.
 *
 * @param {String} provider A valid provider name. `google` and `ms` are currently supported.
 * @param {String} token A token to pass to the server for validation.
 * @returns A promise encapsulating the network request.
 */
function validateTokenForProvider (provider, token) {
  const params = {
    provider,
    id_token: token,
  }

  return new Promise((resolve, reject) => {
    return SVC_A.post('/api/v4/oauth', params).then(res => res.data).then(data => {
      if (!data.ok) {
        return reject(Error(`${data.err}`))
      }

      resolve(data)
    }).catch((err) => {
      router.push({
        path: '/',
        query: {
          message: 'There was a problem logging in.',
          error: err,
        },
      })
      reject(Error('There was a problem logging in.'))
    })
  })
}

function loadPermissionsForUser (userID) {
  console.log(`requesting permissions for ${userID}`)
  return new Promise((resolve, reject) => {
    // resolve(entitlements)
    return SVC_B.get(`/api/v1/users/${userID}/entitlements`).then(res => res.data).then(data => {
      if (!data.ok) {
        return reject(data)
      }
      return resolve(data)
    }).catch((err) => {
      return reject(Error(`There was a problem loading user permissions: ${err}`))
    })
  })
}
